import { NgModule } from '@angular/core';
import { environment } from '@env/environment';

import { NgxsDispatchPluginModule } from '@ngxs-labs/dispatch-decorator';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsModule } from '@ngxs/store';

import { AlertsState } from '@app/alerts/state/alerts.state';
import { ApiStoreConnectService } from './services/api-store-connect.service';
import { AccountsState } from './states/accounts/accounts.state';
import { ActionsState } from './states/actions/actions.state';
import { ApiState } from './states/api/api.state';
import { ChartMetricsState } from './states/chart-metrics/chart-metrics.state';
import { CurrencyState } from './states/currency/currency.state';
import { CustomerState } from './states/customer/customer.state';
import { GlobalFiltersState } from './states/global-filters/global-filters.state';
import { GoalsState } from './states/goals/goals.state';
import { RewardfulState } from './states/rewardful/rewardful.state';
import { RouterNavStateModule } from './states/router-nav/router-nav-state.module';
import { UserState } from './states/user/user.state';

const storeActionSanitizer = (action) => {
  if (action.type?.startsWith('[Router]')) {
    delete action.event;
  }

  return action;
};

@NgModule({
  imports: [
    NgxsModule.forRoot(
      [
        ActionsState,
        UserState,
        CustomerState,
        CurrencyState,
        ApiState,
        AccountsState,
        RewardfulState,
        GlobalFiltersState,
        ChartMetricsState,
        GoalsState,
        AlertsState,
      ],
      {
        developmentMode: !environment.production,
        selectorOptions: { suppressErrors: false },
      },
    ),
    NgxsFormPluginModule.forRoot(),
    NgxsDispatchPluginModule.forRoot(),
    NgxsReduxDevtoolsPluginModule.forRoot({ disabled: environment.production, actionSanitizer: storeActionSanitizer }),

    RouterNavStateModule.forRoot(),
  ],
  providers: [ApiStoreConnectService],
})
export class StoreModule {}
